import React from "react";
import Tablecomponent from "../../helpers/TableComponent/TableComp";
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import "./MedicineModal.css";
import dateFormat from "dateformat";
import Plus from "../../Images/plus.png";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent"
import MedicineModal from "./MedicineModal";
import "./MedicineMaster.css";
import DeleteMedia from "../../helpers/ModalComp/deleteModal";

import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import { message, Input } from "antd";
import ViewMedicine from "./ViewMedicine";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Alert from "../../Images/alert.svg";
import ShowNotification from "../ShowNotification/ShowNotification";
import ArrowLeft from "@material-ui/icons/ChevronLeftSharp";

import Cookies from "js-cookie";

import { decryptAESKey, setupKeys, encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
import { initEncryptionSession } from '../../encryptionSession';
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

class DashboardTable extends React.Component {
  state = {
    search: null,
    openview: false,
    open: true,
    insertOpen: false,
    deleteopen: false,
    editopen: false,
    tableData: [],
    editData: "",
    visible: false,
    successmsg: "",
    issuccess: false,
  };

  componentDidMount() {
    this.getTableData();
    this.intervalId = setInterval(() => {
      this.getTableData();
    }, 120000);
  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted to avoid memory leaks
    clearInterval(this.intervalId);
  }

  getTableData = async () => {
    this.setState({ props_loading: true });
    var tableData = [];
    var self = this;
    const aesKey = await initEncryptionSession();
    const pharmId = Cookies.get("pharmacy_id") || localStorage.getItem("pharmacy_id") || localStorage.pharmacy_id || 0;
    var data = {
      pharmacy_id: (pharmId && pharmId !== "undefined" && pharmId !== "null") ? Number(pharmId) : 0,
      pageNumber: 0,
      pageSize: 0,
    };
    const encrypted = await encryptData(data, aesKey);
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/get_mas_pharm_medicine_rate",
      data: {
        objects: encrypted
      },
    })
      .then(async (response) => {
        let dataList = [];
        if (response.data && response.data.status === 1 && response.data.data) {
          if (typeof response.data.data === "string") {
            dataList = await decryptData(response.data.data, aesKey);
          } else if (Array.isArray(response.data.data)) {
            dataList = response.data.data;
          }
        }
        if (Array.isArray(dataList)) {
          dataList.map((val) => {
            tableData.push({
              medicineName: val.medicine_name,
              dosage: val.dosage,
              medicineRate: val.unit_rate,
              id: val.id,
              incentive: val.commission_percentage,
              salesApprovalSts: val.sales_admin_sts,
            });
          });
        }
        self.setState({
          tableData,
          props_loading: false,
          totalData: dataList,
        });
      })
      .catch((error) => {
        console.error(error);
        self.setState({ props_loading: false });
      });
  };

  deleteopen = (type, id) => {
    this.setState({
      deleteopen: true,
      iddata: id,
    });
  };

  deleterow = () => {
    this.setState({ props_loading: true });

    var self = this;
    axiosInstance({
      method: "delete",
      url: apiurl + "pharmacy/delete_mas_pharm_medicine_rate",
      data: {
        id: this.state.iddata,
      },
    })
      .then(function (response) {
        console.log(response, "deleteres");
        // const { t } = this.props;
        // const medicine_deleted = t("medicine_deleted");
        // // self.handleopenSuccess("Medicine deleted successfully!", true);
        if (localStorage.pharmacy_language == 'ar') {
          self.handleopenSuccess("!تم حذف الدواء بنجاح", true);
          self.getTableData();
        } else {
          self.handleopenSuccess("Medicine deleted successfully!", true);
          self.getTableData();
        }

      })
      .catch(function (error) {
        console.log(error, "error");
      });

    this.setState({ props_loading: false });
  };

  modelopen = (data, id) => {
    if (data === "view") {
      this.setState({ openview: true });
      this.setState({
        viewMedicineData: this.state.totalData.find((val) => val.id === id),
      });
    } else if (data === "edit") {
      this.setState({ editopen: true });
      this.setState({
        editData: this.state.totalData.find((val) => val.id === id),
      });
    }
  };

  closemodal = () => {
    this.setState({
      openview: false,
      insertOpen: false,
      editopen: false,
      deleteopen: false,
    });
  };

  iconclick = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleClickOpen = () => {
    this.setState({ insertOpen: true });
  };

  handleopenSuccess = (successmsg, issuccess) => {
    this.setState({ visible: true, successmsg, issuccess });
  };

  handleCloseSuccess = () => {
    this.setState({ visible: false });
  };

  render() {
    const { t } = this.props;
    const heading =
      localStorage.pharmacy_language == "ar"
        ? [
          { id: "", label: t("tbl_head_remarks") },
          { id: "salesApprovalSts", label: t("approved_status_medicine") },
          { id: "incentive", label: t("incentive_percentage") },
          { id: "medicineRate", label: t("unit_rate_with_kwd") },
          { id: "medicineName", label: t("medicine_name") },
          { id: "sno", label: t("tbl_head_s_no") },
        ]
        : [
          { id: "sno", label: t("tbl_head_s_no") },
          { id: "medicineName", label: t("medicine_name") },
          { id: "medicineRate", label: t("unit_rate_with_kwd") },
          { id: "incentive", label: t("incentive_percentage") },
          { id: "salesApprovalSts", label: t("approved_status_medicine") },
          { id: "", label: t("tbl_head_remarks") },
        ];
    const { Search } = Input;
    var searchData = [];
    this.state.tableData.filter((val) => {
      if (this.state.search === null) {
        searchData.push({
          medicineName: val.medicineName,
          // dosage: val.dosage
          medicineRate: val.medicineRate,
          incentive: val.incentive,
          salesApprovalSts: val.salesApprovalSts,
          id: val.id,
        });
      } else if (
        (val.medicineName != null &&
          val.medicineName
            .toLowerCase()
            .includes(this.state.search.toLowerCase())) ||
        // || val.dosage != null && val.dosage.toString().includes(this.state.search.toString())
        (val.medicineRate != null &&
          val.medicineRate.toString().includes(this.state.search.toString())) ||
        (val.incentive != null &&
          val.incentive.toString().includes(this.state.search.toString())) ||
        (val.salesApprovalSts != null &&
          val.salesApprovalSts
            .toString()
            .includes(this.state.search.toString()))
      ) {
        searchData.push({
          medicineName: val.medicineName,
          // dosage: val.dosage,
          medicineRate: val.medicineRate,
          incentive: val.incentive,
          salesApprovalSts: val.salesApprovalSts,
          id: val.id,
        });
      }
    });
    // alert(JSON.stringify(searchData))
    return (
      <div>
        <div className="uploadsmasterheader medicine_rate_head_siv">
          <div className="titlerevenue">
            {this.props.isfromverification && (
              <ArrowLeft
                className="left_arrow_dashboard"
                onClick={() => {
                  this.props.backVerification();
                }}
              >
                {" "}
              </ArrowLeft>
            )}
            {t("manage_medicine_head")}
          </div>
          <div style={{
            display: (localStorage.pharmacy_language == 'ar' ? 'flex' : ''),
            gap: (localStorage.pharmacy_language == 'ar' ? '15px' : '')
          }}>
            <Search
              className={`${this.props.i18n.language == "ar" ? "order_1" : ""
                } mr-5`}
              placeholder="Search"
              onSearch={(value) => console.log(value)}
              style={{ width: 150 }}
              onChange={(e) => this.setState({ search: e.target.value })}
            />
            <img
              src={Plus}
              onClick={this.handleClickOpen}
              className="pc_icon"
            />
          </div>
        </div>
        <div className="medicine_rate_div">
          <Tablecomponent
            heading={heading}
            rowdata={searchData}
            tableicon_align={""}
            modelopen={(e, id) => this.modelopen(e, id)}
            deleteopen={this.deleteopen}
            getTableData={this.getTableData}
            handleopenSuccess={this.handleopenSuccess}
            closemodal={() => this.closemodal()}
            props_loading={this.state.props_loading}
            t={t}
            i18n={this.props.i18n}
          />
        </div>

        <Modalcomp
          clrchange="text_color"
          visible={
            this.state.insertOpen ? this.state.insertOpen : this.state.editopen
          }
          title={
            this.state.insertOpen ? t("add_medicine_rate") : t("edit_detail")
          }
          closemodal={(e) => this.closemodal(e)}
          fullWidth={false}
          xswidth={"sm"}
          modelwidthClass={`${this.props.i18n.language == "ar" ? "arabic_cls" : ""
            } `}
          t={t}
          i18n={this.props.i18n}
        >
          <MedicineModal
            getTableData={this.getTableData}
            closemodal={() => this.closemodal()}
            editData={this.state.editData}
            editOpenModal={this.state.editopen}
            handleopenSuccess={this.handleopenSuccess}
            t={t}
            i18n={this.props.i18n}
          />
        </Modalcomp>

        <Modalcomp
          clrchange="text_color"
          visible={this.state.openview}
          // title={"VIEW MEDICINE"}
          title={t("view_medicine")}
          closemodal={this.closemodal}
          fullWidth={false}
          xswidth={"sm"}
          modelwidthClass={`${this.props.i18n.language == "ar" ? "arabic_cls" : ""
            } `}
          t={t}
          i18n={this.props.i18n}
        >
          <ViewMedicine
            viewMedicineData={this.state.viewMedicineData}
            closemodal={this.closemodal}
            t={t}
            i18n={this.props.i18n}
          />
        </Modalcomp>

        <Dialog
          className={`${this.props.i18n.language == "ar" ? "arabic_cls" : ""
            } Dialogmodal delete_medicine`}
          // onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.deleteopen}
          fullWidth={true}
          disableBackdropClick={true}
          maxWidth={"xs"}
        >
          <DialogContent dividers className="DialogContent">
            <Grid container>
              <Grid xs={12} md={12} style={{ textAlign: "center" }}>
                <img src={Alert} className="common_success_tick_mark" />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                className="delete_media_title_container common_delete_div"
              >
                <div className="alert_titile">{t("alert_head")}</div>
                <div className="mediadelete_container mb-3 mt-3">
                  <p className="delete_para">{t("delete_medicine_txt")}</p>
                </div>
                <div
                  className="mediadelete_container"
                  style={{
                    direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : ''),
                    gap: (localStorage.pharmacy_language == 'ar' ? '15px' : ''),
                  }}
                  onClick={() => this.closemodal()}
                >
                  <Button className="detete_no">{t("no")}</Button>
                  <Button
                    className="detete_yes"
                    onClick={() => this.deleterow()}
                  >
                    {t("yes")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        {/* <Modalcomp
          visible={this.state.deleteopen}
          title={"Delete"}
          closemodal={this.closemodal}
          customwidth_dialog="cus_wid_delmodel"
          xswidth={"xs"}
        >
          <DeleteMedia
            deleterow={this.deleterow}
            closemodal={this.closemodal}
          />
        </Modalcomp> */}

        <ShowNotification
          visible={this.state.visible}
          successmsg={this.state.successmsg}
          issuccess={this.state.issuccess}
          handleCloseSuccess={this.handleCloseSuccess}
          t={t}
          i18n={this.props.i18n}
        ></ShowNotification>
      </div>
    );
  }
}

export default DashboardTable;
